// Mirrors the API's DepartmentLevel enum. Keyed on depth, not description -- the
// description is a renameable display label.
export enum DepartmentLevelDepth {
    Company = 1,
    Division = 2,
    Department = 3,
}

export interface DepartmentLevel {
    id: string
    depth: number
    description: string
    createdAt?: Date
    updatedAt?: Date
}
